import { RootState } from 'store/index';

export const selectIntegrationsList = (state: RootState) => {
  return state.integrations.list;
};

export const selectJamfSettingsPath = (state: RootState) => {
  const integrationsList = state.integrations.list;
  const jamfIntegration = integrationsList.enabled.find(integration => integration.key === 'jamf');
  return jamfIntegration?.settingsPath || '/integrations/jamf/settings';
};
